import { memo, useEffect } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import BuilderModeDataTableOpzV2 from 'pages/BuilderMode/BuilderModeDataTableOpzV2';
import {
  FetchPlannerBlockMetadata,
  getBaseScenario,
  getPlannerBlockMetadataScenarioId,
  getToolbarType,
} from 'redux/PlannerModeSlice';
import { AppDispatch } from 'utils/GlobalHelpers';

import AddIndicatorTableFooterV1 from '../components/AddIndicatorTableFooterV1';
import { BUILDER_MODE_V1_LAYOUT } from '../constants';

import './BuilderModeDataTableV1.scss';

/**
 * Reuses existing BuilderMode `BuilderModeDataTableOpzV2` logic,
 * but overrides legacy `Table.scss` look to match BuilderModeV1 (Figma 75644:17270).
 */
const BuilderModeDataTableV1 = memo(() => {
  const { blockId } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const baseScenario = useSelector(getBaseScenario);
  const blockMetadataScenarioId = useSelector(getPlannerBlockMetadataScenarioId);
  const toolbarType = useSelector(getToolbarType);

  useEffect(() => {
    if (!baseScenario?.id || !blockId || toolbarType !== 'Data') {
      return;
    }

    const metadataAlreadyLoadedForScenario = blockMetadataScenarioId === baseScenario.id;
    if (metadataAlreadyLoadedForScenario) return;

    dispatch(
      FetchPlannerBlockMetadata({
        blockId: Number(blockId),
        parameters: { scenario_id: baseScenario.id },
      }),
    );
  }, [baseScenario?.id, blockId, blockMetadataScenarioId, toolbarType, dispatch]);

  return (
    <Flex
      direction='column'
      gap={BUILDER_MODE_V1_LAYOUT.addIndicatorTableGap}
      width='100%'
      flex='0 1 auto'
      alignSelf='flex-start'
      maxH={BUILDER_MODE_V1_LAYOUT.tablePanelMaxHeight}
      minH={0}
    >
      <Box
        className='builder-mode-v1-data-table'
        width='100%'
        flex='1 1 auto'
        minH={0}
        overflow='hidden'
        display='flex'
        flexDirection='column'
        borderRadius='16px'
        border='1px solid'
        borderColor='blockOverview.border'
        bg='white'
      >
        <BuilderModeDataTableOpzV2 contentBasedColumnWidths hideTableAddRow />
      </Box>
      <AddIndicatorTableFooterV1 />
    </Flex>
  );
});

BuilderModeDataTableV1.displayName = 'BuilderModeDataTableV1';

export default BuilderModeDataTableV1;
